import { render, staticRenderFns } from "./TarimaComponent.vue?vue&type=template&id=70d4f5ee&"
import script from "./TarimaComponent.vue?vue&type=script&lang=js&"
export * from "./TarimaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports